import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { UiLegacy } from "@silvertours/front-legacy-shared";
import { Ui } from "@silvertours/front-shared";
import { useFormatter, useMessages, useTranslations } from "next-intl";
import Cancel24H from "@engineering/icons/cancel24h";
import Checked from "@engineering/icons/checked";
import FloytCut from "@engineering/icons/floyt-cut";
import Help from "@engineering/icons/help";
import Like from "@engineering/icons/like";
import MapView from "@engineering/icons/map-view";
import Phone from "@engineering/icons/phone";
import StarEmpty from "@engineering/icons/star-empty";
import World from "@engineering/icons/world";
import { IconWrapper, RatingContainer, UspContainer, UspItem, UspItems, UspTitleContainer, UspTitle } from "./Benefits.styles";
var icons = {
    Cancel24H: Cancel24H,
    Checked: Checked,
    FloytCut: FloytCut,
    MapView: MapView,
    StarEmpty: StarEmpty,
    Help: Help,
    Phone: Phone,
    Like: Like,
    World: World
};
var Usp = function(param) {
    var title = param.title, rating = param.rating, _translationKey = param.translationKey, translationKey = _translationKey === void 0 ? "usps" : _translationKey;
    var t = useTranslations("features.benefitsLegacy.".concat(translationKey));
    var formatter = useFormatter();
    var messages = useMessages();
    var items = Object.keys(messages.features.benefitsLegacy[translationKey].content);
    var makeTranslateKey = function(item) {
        return function(key, values) {
            return t("content.".concat(item, ".").concat(key), values);
        };
    };
    return /*#__PURE__*/ _jsxs(UspContainer, {
        children: [
            Boolean(title) && /*#__PURE__*/ _jsx(UspTitleContainer, {
                children: /*#__PURE__*/ _jsx(UiLegacy.PrimaryTitle, {
                    children: title
                })
            }),
            /*#__PURE__*/ _jsx(UspItems, {
                children: items.filter(function(item) {
                    return !(item === "customerReviews" && !rating);
                }).map(function(item) {
                    var translateKey = makeTranslateKey(item);
                    if (rating && item === "customerReviews") {
                        var reviewsCount = formatter.number(rating.count, {
                            useGrouping: true
                        });
                        var averageRating = formatter.number(rating.averageRating, {
                            maximumFractionDigits: 1
                        });
                        var Icon = icons[translateKey("icon")];
                        return /*#__PURE__*/ _jsxs(UspItem, {
                            children: [
                                Icon && /*#__PURE__*/ _jsx(IconWrapper, {
                                    children: /*#__PURE__*/ _jsx(Icon, {})
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        /*#__PURE__*/ _jsx(UspTitle, {
                                            children: translateKey("title")
                                        }),
                                        /*#__PURE__*/ _jsx(Ui.TextLink, {
                                            href: "".concat(t("ratingSlug"), ".html"),
                                            text: translateKey("description", {
                                                reviewsCount: reviewsCount
                                            })
                                        }),
                                        /*#__PURE__*/ _jsxs(RatingContainer, {
                                            children: [
                                                /*#__PURE__*/ _jsx(UiLegacy.Rating, {
                                                    value: rating.averageRating,
                                                    starSize: "large"
                                                }),
                                                /*#__PURE__*/ _jsx(UiLegacy.SmallText, {
                                                    children: /*#__PURE__*/ _jsxs("b", {
                                                        children: [
                                                            averageRating,
                                                            " / 5"
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, item);
                    }
                    var Icon1 = icons[translateKey("icon")];
                    return /*#__PURE__*/ _jsxs(UspItem, {
                        children: [
                            Icon1 && /*#__PURE__*/ _jsx(IconWrapper, {
                                children: /*#__PURE__*/ _jsx(Icon1, {})
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsx(UspTitle, {
                                        children: translateKey("href") ? /*#__PURE__*/ _jsx("a", {
                                            href: translateKey("href"),
                                            children: translateKey("title")
                                        }) : translateKey("title")
                                    }),
                                    translateKey("description")
                                ]
                            })
                        ]
                    }, item);
                })
            })
        ]
    });
};
export { Usp };
